<div
  class="row component-card align-items-center my-5 text-img-container"
  *ngFor="let item of data.details.services"
>
  <h3 class="text-center" *ngIf="data?.details.title">
    {{ data.details.title.split(" ")[0] }}
    <span> {{ data.details.title.split(" ").slice(1).join(" ") }}</span>
  </h3>
  <div class="col-12 col-md-7 my-auto px-4 order-2 order-md-1">
    <!-- <h1>{{ item.titleTr }}</h1> -->
    <h5 class="mb-4" [innerHTML]="item.summary"></h5>
    <a
      class="btn"
      [href]="getDetailsUrl(item)"
      *ngIf="data.details.isDetails"
      >{{ "details" | translate }}</a
    >
  </div>
  <div class="col-12 col-md-5 text-center p-0 img-fluid order-1 order-md-2">
    <img class="w-100" [src]="item.imageIconPath" [alt]="item.imageAlt" />
  </div>
</div>
